import { render, staticRenderFns } from "./BinLocationPickersAk.vue?vue&type=template&id=5fa42880&scoped=true&"
import script from "./BinLocationPickersAk.vue?vue&type=script&lang=js&"
export * from "./BinLocationPickersAk.vue?vue&type=script&lang=js&"
import style0 from "./BinLocationPickersAk.vue?vue&type=style&index=0&id=5fa42880&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa42880",
  null
  
)

export default component.exports